import { resolveContact } from '../contacts/mappers';
export const selectCurrentContact = (state) => resolveContact(state.contacts, state.contact.currentContactId);
/** Mask id of the current single-profile search result. */
export const selectContactMaskId = (state) => { var _a, _b; return (_b = (_a = state.contact.metadata) === null || _a === void 0 ? void 0 : _a.maskId) !== null && _b !== void 0 ? _b : null; };
